<ng-container *ngIf="requests.length > 0">
  <p-card header="Zahtevi za support pristup" styleClass="p-mb-3">
    <p-table [value]="requests" [loading]="isLoading">
      <ng-template pTemplate="header">
        <tr>
          <th>Podneo zahtev</th>
          <th>Datum</th>
          <th>Status</th>
          <th>Ističe</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-request>
        <tr>
          <td>{{ request.requestedByName }} ({{ request.requestedByEmail }})</td>
          <td>{{ request.requestedAt | date:'dd.MM.yyyy HH:mm' }}</td>
          <td>{{ request.status }}</td>
          <td>{{ request.expiresAt | date:'dd.MM.yyyy HH:mm' }}</td>
          <td>
            <ng-container *ngIf="request.status === 'PENDING'">
              <p-button
                label="Odobri"
                icon="pi pi-check"
                styleClass="p-button-success p-mr-2"
                (onClick)="handleApprove(request)">
              </p-button>
              <p-button
                label="Odbij"
                icon="pi pi-times"
                styleClass="p-button-danger"
                (onClick)="handleReject(request)">
              </p-button>
            </ng-container>
            <span *ngIf="request.status === 'APPROVED'" class="p-tag p-tag-success">
              Test korisnik: {{ request.testUserEmail }}
            </span>
            <span *ngIf="request.status === 'REJECTED'" class="p-tag p-tag-danger">
              Odbijen
            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</ng-container>
